// import {createContext } from "react";

// const FileContext = createContext();

// export default FileContext;
// import { createContext, useState, useCallback } from "react";

// const FileContext = createContext();

// const FileProvider = ({ children }) => {
//   const [capturedInspectionImages, setCapturedInspectionImages] = useState([]);
//   const [capturedImages360, setCapturedImages360] = useState([]);
//   const [capturedImageWindshield, setCapturedImageWindshield] = useState([]);
//   const [capturedChassisRC, setCapturedChassisRC] = useState([]);
//   const [capturedRegNo, setCapturedRegNo] = useState([]);
//   const [capturedOdometer, setCapturedOdometer] = useState([]);
//   const [capturedTyres, setCapturedTyres] = useState([]);
//   const [odometerVideo, setOdometerVideo] = useState(null);
//   const [engineVideo, setEngineVideo] = useState(null); // Add if missing

//   // Reset function to clear all captured data
//   const resetAllCapturedData = useCallback(() => {
//     console.log("Resetting all captured data in context");
//     setCapturedInspectionImages([]);
//     setCapturedImages360([]);
//     setCapturedImageWindshield([]);
//     setCapturedChassisRC([]);
//     setCapturedRegNo([]);
//     setCapturedOdometer([]);
//     setCapturedTyres([]);
//     setOdometerVideo(null);
//     setEngineVideo(null);
//   }, []);

//   return (
//     <FileContext.Provider
//       value={{
//         // State
//         capturedInspectionImages,
//         capturedImages360,
//         capturedImageWindshield,
//         capturedChassisRC,
//         capturedRegNo,
//         capturedOdometer,
//         capturedTyres,
//         odometerVideo,
//         engineVideo,
        
//         // Setters
//         setCapturedInspectionImages,
//         setCapturedImages360,
//         setCapturedImageWindshield,
//         setCapturedChassisRC,
//         setCapturedRegNo,
//         setCapturedOdometer,
//         setCapturedTyres,
//         setOdometerVideo,
//         setEngineVideo,
        
//         // Reset function
//         resetAllCapturedData
//       }}
//     >
//       {children}
//     </FileContext.Provider>
//   );
// };
// export { FileContext };
// export default FileProvider;
// import { createContext, useState, useCallback } from "react";

// export const FileContext = createContext();

// const FileProvider = ({ children }) => {
//   const [capturedInspectionImages, setCapturedInspectionImages] = useState([]);
//   const [capturedImages360, setCapturedImages360] = useState([]);
//   const [capturedImageWindshield, setCapturedImageWindshield] = useState([]);
//   const [capturedChassisRC, setCapturedChassisRC] = useState([]);
//   const [capturedRegNo, setCapturedRegNo] = useState([]);
//   const [capturedOdometer, setCapturedOdometer] = useState([]);
//   const [capturedTyres, setCapturedTyres] = useState([]);
//   const [odometerVideo, setOdometerVideo] = useState(null);
//   const [engineVideo, setEngineVideo] = useState(null);

//   const resetAllCapturedData = useCallback(() => {
//     setCapturedInspectionImages([]);
//     setCapturedImages360([]);
//     setCapturedImageWindshield([]);
//     setCapturedChassisRC([]);
//     setCapturedRegNo([]);
//     setCapturedOdometer([]);
//     setCapturedTyres([]);
//     setOdometerVideo(null);
//     setEngineVideo(null);
//   }, []);

//   return (
//     <FileContext.Provider
//       value={{
//         capturedInspectionImages,
//         capturedImages360,
//         capturedImageWindshield,
//         capturedChassisRC,
//         capturedRegNo,
//         capturedOdometer,
//         capturedTyres,
//         odometerVideo,
//         engineVideo,

//         setCapturedInspectionImages,
//         setCapturedImages360,
//         setCapturedImageWindshield,
//         setCapturedChassisRC,
//         setCapturedRegNo,
//         setCapturedOdometer,
//         setCapturedTyres,
//         setOdometerVideo,
//         setEngineVideo,

//         resetAllCapturedData,
//       }}
//     >
//       {children}
//     </FileContext.Provider>
//   );
// };

// export default FileProvider;
import { createContext, useState, useCallback } from "react";

// ✅ keep a real context object
export const FileContext = createContext();

// ✅ make Provider a NAMED export
export const FileProvider = ({ children }) => {
  const [capturedInspectionImages, setCapturedInspectionImages] = useState([]);
  const [capturedImages360, setCapturedImages360] = useState([]);
  const [capturedImageWindshield, setCapturedImageWindshield] = useState([]);
  const [capturedChassisRC, setCapturedChassisRC] = useState([]);
  const [capturedRegNo, setCapturedRegNo] = useState([]);
  const [capturedOdometer, setCapturedOdometer] = useState([]);
  const [capturedTyres, setCapturedTyres] = useState([]);
  const [odometerVideo, setOdometerVideo] = useState(null);
  const [engineVideo, setEngineVideo] = useState(null);

  const resetAllCapturedData = useCallback(() => {
    setCapturedInspectionImages([]);
    setCapturedImages360([]);
    setCapturedImageWindshield([]);
    setCapturedChassisRC([]);
    setCapturedRegNo([]);
    setCapturedOdometer([]);
    setCapturedTyres([]);
    setOdometerVideo(null);
    setEngineVideo(null);
  }, []);

  return (
    <FileContext.Provider
      value={{
        capturedInspectionImages,
        capturedImages360,
        capturedImageWindshield,
        capturedChassisRC,
        capturedRegNo,
        capturedOdometer,
        capturedTyres,
        odometerVideo,
        engineVideo,

        setCapturedInspectionImages,
        setCapturedImages360,
        setCapturedImageWindshield,
        setCapturedChassisRC,
        setCapturedRegNo,
        setCapturedOdometer,
        setCapturedTyres,
        setOdometerVideo,
        setEngineVideo,

        resetAllCapturedData,
      }}
    >
      {children}
    </FileContext.Provider>
  );
};

// ✅ DEFAULT export stays FileContext for the whole repo
export default FileContext;
// import { useState } from "react";
// import  { FileContext } from "./Context";

// const FileContextProvider = ({ children }) => {
//   const [capturedImages360, setCapturedImages360] = useState([]);
//   const [capturedImageWindshield, setCapturedImageWindshield] = useState([]);
//   const [capturedChassisRC, setCapturedChassisRC] = useState([]);
//   const [capturedRegNo, setCapturedRegNo] = useState([]);
//   const [capturedOdometer,setCapturedOdometer]=useState([]);
//   const [capturedTyres,setCapturedTyres]=useState([]);
//   const [capturedInspectionImages, setCapturedInspectionImages] = useState([]);
//   const [capturedVideo,setCapturedVideo] =useState(null);
//   const [odometerVideo,setOdometerVideo]=useState(null);
//   const [carView,setCarView]=useState(null);
//   const [isBack,setIsBack]=useState(0);
  
//   return (
//     <FileContext.Provider
//       value={{
//         capturedImages360,
//         setCapturedImages360,
//         capturedImageWindshield,
//         setCapturedImageWindshield,
//         capturedChassisRC,
//         setCapturedChassisRC,
//         capturedRegNo,
//         setCapturedRegNo,
//         capturedOdometer,
//         setCapturedOdometer,
//         capturedTyres,
//         setCapturedTyres,
//         isBack,
//         setIsBack,
//         capturedInspectionImages,
//         setCapturedInspectionImages,
//         capturedVideo,
//         setCapturedVideo,
//         odometerVideo,
//         setOdometerVideo,
//         carView,
//         setCarView
//       }}
//     >
//       {children}
//     </FileContext.Provider>
//   );
// };

// export default FileContextProvider;